<template>
  <div id="digital-flop">
    <div
      class="digital-flop-item"
      v-for="item in digitalFlopData"
      :key="item.title"
    >
      <div class="digital-flop-title">{{ item.title }}</div>
      <div class="digital-flop">
        <dv-digital-flop
          :config="item.number"
          style="width:100px;height:50px;"
        />
          <div class="unit">{{ item.unit }}</div>
      </div>
    </div>

    <dv-decoration-10 />
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'DigitalFlop',
  data () {
    return {
      digitalFlopData: []
    }
  },
  methods: {
    initData() {
      let that = this
      axios({
        method:'get',
        url: that.baseUrl + "/datav/head/auth"
      }).then(function(resp){
        let res = resp.data;
        if (res.code === 200) {
          let data = res.data;
          that.digitalFlopData = [
            {
              title: '入库数量',
              number: {
                number: [data.pakin],
                content: '{nt}',
                textAlign: 'right',
                style: {
                  fill: '#4d99fc',
                  fontWeight: 'bold'
                }
              },
              unit: ''
            },
            {
              title: '出库数量',
              number: {
                number: [data.pakout],
                content: '{nt}',
                textAlign: 'right',
                style: {
                  fill: '#f46827',
                  fontWeight: 'bold'
                }
              },
              unit: ''
            },
            {
              title: '在库数量',
              number: {
                number: [data.locDetl],
                content: '{nt}',
                textAlign: 'right',
                style: {
                  fill: '#40faee',
                  fontWeight: 'bold'
                }
              },
              unit: ''
            },
            {
              title: '订单量',
              number: {
                number: [data.order],
                content: '{nt}',
                textAlign: 'right',
                style: {
                  fill: '#4d99fc',
                  fontWeight: 'bold'
                }
              },
              unit: ''
            },
            {
              title: '商品总量',
              number: {
                number: [data.mat],
                content: '{nt}',
                textAlign: 'right',
                style: {
                  fill: '#f46827',
                  fontWeight: 'bold'
                }
              },
              unit: ''
            },
            {
              title: '货位总数',
              number: {
                number: [data.node],
                content: '{nt}',
                textAlign: 'right',
                style: {
                  fill: '#40faee',
                  fontWeight: 'bold'
                }
              },
              unit: ''
            },
            {
              title: '客户数',
              number: {
                number: [data.cstmr],
                content: '{nt}',
                textAlign: 'right',
                style: {
                  fill: '#4d99fc',
                  fontWeight: 'bold'
                }
              },
              unit: ''
            },
            {
              title: '用户数量',
              number: {
                number: [data.user],
                content: '{nt}',
                textAlign: 'right',
                style: {
                  fill: '#f46827',
                  fontWeight: 'bold'
                }
              },
              unit: ''
            },
            {
              title: '操作次数',
              number: {
                number: [data.opt],
                content: '{nt}',
                textAlign: 'right',
                style: {
                  fill: '#40faee',
                  fontWeight: 'bold'
                }
              },
              unit: ''
            }
          ]
        }
      }).catch(resp => {
        console.log('请求失败：' + resp.status + ',' + resp.statusText);
      });
    }
  },
  mounted () {
    const { initData } = this
    initData()
    setInterval(initData, 10000)
  }
}
</script>

<style lang="less">
#digital-flop {
  position: relative;
  height: 15%;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(6, 30, 93, 0.5);

  .dv-decoration-10 {
    position: absolute;
    width: 95%;
    left: 2.5%;
    height: 5px;
    bottom: 0px;
  }

  .digital-flop-item {
    width: 11%;
    height: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-left: 3px solid rgb(6, 30, 93);
    border-right: 3px solid rgb(6, 30, 93);
  }

  .digital-flop-title {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .digital-flop {
    display: flex;
  }

  .unit {
    margin-left: 10px;
    display: flex;
    align-items: flex-end;
    box-sizing: border-box;
    padding-bottom: 13px;
  }
}
</style>
